// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file travplaces/v1/city_categories.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_travplaces_v1_audit } from "./audit_pb";
import { file_travplaces_v1_authz } from "./authz_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file travplaces/v1/city_categories.proto.
 */
export const file_travplaces_v1_city_categories: GenFile = /*@__PURE__*/
  fileDesc("CiN0cmF2cGxhY2VzL3YxL2NpdHlfY2F0ZWdvcmllcy5wcm90bxINdHJhdnBsYWNlcy52MSLwAQoMQ2l0eUNhdGVnb3J5EgoKAmlkGAEgASgJEgsKA2tleRgCIAEoCRINCgVsYWJlbBgDIAEoCRIWCg5jYXRlZ29yeV9ncm91cBgEIAEoCRIMCgRpY29uGAUgASgJEh0KFWRlZmF1bHRfZHdlbGxfbWludXRlcxgGIAEoBRIgChhpc19zYWZldHlfaW5mcmFzdHJ1Y3R1cmUYByABKAgSFAoMaXNfYXZvaWRhYmxlGAggASgIEhQKDGlzX3Zpc2l0YWJsZRgJIAEoCBISCgpzb3J0X29yZGVyGAogASgFEhEKCXBvaV9jb3VudBgLIAEoAyIsChlMaXN0Q2l0eUNhdGVnb3JpZXNSZXF1ZXN0Eg8KB2NpdHlfaWQYASABKAkiTQoaTGlzdENpdHlDYXRlZ29yaWVzUmVzcG9uc2USLwoKY2F0ZWdvcmllcxgBIAMoCzIbLnRyYXZwbGFjZXMudjEuQ2l0eUNhdGVnb3J5Mo0BChNDaXR5Q2F0ZWdvcnlTZXJ2aWNlEnYKEkxpc3RDaXR5Q2F0ZWdvcmllcxIoLnRyYXZwbGFjZXMudjEuTGlzdENpdHlDYXRlZ29yaWVzUmVxdWVzdBopLnRyYXZwbGFjZXMudjEuTGlzdENpdHlDYXRlZ29yaWVzUmVzcG9uc2UiC4rqMAMKAQqQ6jABQq4BChFjb20udHJhdnBsYWNlcy52MUITQ2l0eUNhdGVnb3JpZXNQcm90b1ABWi90cmF2cGxhY2VzL2dlbi9wcm90by90cmF2cGxhY2VzL3YxO3RyYXZwbGFjZXN2MaICA1RYWKoCDVRyYXZwbGFjZXMuVjHKAg1UcmF2cGxhY2VzXFYx4gIZVHJhdnBsYWNlc1xWMVxHUEJNZXRhZGF0YeoCDlRyYXZwbGFjZXM6OlYxYgZwcm90bzM", [file_travplaces_v1_audit, file_travplaces_v1_authz]);

/**
 * CityCategory is a Category enriched with the number of active POIs it has in
 * a given city. It drives the planner's category picker, where each chip shows
 * how many places the traveller could browse under that category.
 *
 * @generated from message travplaces.v1.CityCategory
 */
export type CityCategory = Message<"travplaces.v1.CityCategory"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string key = 2;
   */
  key: string;

  /**
   * @generated from field: string label = 3;
   */
  label: string;

  /**
   * @generated from field: string category_group = 4;
   */
  categoryGroup: string;

  /**
   * @generated from field: string icon = 5;
   */
  icon: string;

  /**
   * @generated from field: int32 default_dwell_minutes = 6;
   */
  defaultDwellMinutes: number;

  /**
   * @generated from field: bool is_safety_infrastructure = 7;
   */
  isSafetyInfrastructure: boolean;

  /**
   * @generated from field: bool is_avoidable = 8;
   */
  isAvoidable: boolean;

  /**
   * @generated from field: bool is_visitable = 9;
   */
  isVisitable: boolean;

  /**
   * @generated from field: int32 sort_order = 10;
   */
  sortOrder: number;

  /**
   * @generated from field: int64 poi_count = 11;
   */
  poiCount: bigint;
};

/**
 * Describes the message travplaces.v1.CityCategory.
 * Use `create(CityCategorySchema)` to create a new message.
 */
export const CityCategorySchema: GenMessage<CityCategory> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_city_categories, 0);

/**
 * @generated from message travplaces.v1.ListCityCategoriesRequest
 */
export type ListCityCategoriesRequest = Message<"travplaces.v1.ListCityCategoriesRequest"> & {
  /**
   * @generated from field: string city_id = 1;
   */
  cityId: string;
};

/**
 * Describes the message travplaces.v1.ListCityCategoriesRequest.
 * Use `create(ListCityCategoriesRequestSchema)` to create a new message.
 */
export const ListCityCategoriesRequestSchema: GenMessage<ListCityCategoriesRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_city_categories, 1);

/**
 * @generated from message travplaces.v1.ListCityCategoriesResponse
 */
export type ListCityCategoriesResponse = Message<"travplaces.v1.ListCityCategoriesResponse"> & {
  /**
   * @generated from field: repeated travplaces.v1.CityCategory categories = 1;
   */
  categories: CityCategory[];
};

/**
 * Describes the message travplaces.v1.ListCityCategoriesResponse.
 * Use `create(ListCityCategoriesResponseSchema)` to create a new message.
 */
export const ListCityCategoriesResponseSchema: GenMessage<ListCityCategoriesResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_city_categories, 2);

/**
 * CityCategoryService exposes per-city category counts for the planner.
 *
 * @generated from service travplaces.v1.CityCategoryService
 */
export const CityCategoryService: GenService<{
  /**
   * ListCityCategories returns every category with its active-POI count for the
   * given city, in display order.
   *
   * @generated from rpc travplaces.v1.CityCategoryService.ListCityCategories
   */
  listCityCategories: {
    methodKind: "unary";
    input: typeof ListCityCategoriesRequestSchema;
    output: typeof ListCityCategoriesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_travplaces_v1_city_categories, 0);

